module.exports = __webpack_public_path__ + "c1267b50c1505db99e1547da06e721fb.jpg";